import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
import { ThemeSelectors, TypePrius } from '@at/design-system-foundation';
export var BackToTop = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: transparent;\n    border: 0;\n    display: block;\n    margin: 0 auto ", ";\n    text-align: center;\n    cursor: pointer;\n\n    &:focus-visible {\n        outline: 1px auto ", ";\n    }\n"], ["\n    background: transparent;\n    border: 0;\n    display: block;\n    margin: 0 auto ", ";\n    text-align: center;\n    cursor: pointer;\n\n    &:focus-visible {\n        outline: 1px auto ", ";\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return ThemeSelectors.getGroupFourSpacing(theme);
}, function (_a) {
    var theme = _a.theme;
    return theme.color.border.focus;
});
export var BackToTopText = styled(TypePrius)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: ", ";\n    margin-top: ", ";\n"], ["\n    color: ", ";\n    margin-top: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.color.text.title;
}, function (_a) {
    var theme = _a.theme;
    return ThemeSelectors.getGroupTwoSpacing(theme);
});
export var BackToTopIcon = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    border: 2px solid ", ";\n    border-radius: 30px;\n    width: 30px;\n    height: 30px;\n    display: flex;\n    margin: 0 auto;\n    align-items: center;\n    justify-content: center;\n\n    svg {\n        path {\n            fill: ", ";\n        }\n    }\n"], ["\n    border: 2px solid ", ";\n    border-radius: 30px;\n    width: 30px;\n    height: 30px;\n    display: flex;\n    margin: 0 auto;\n    align-items: center;\n    justify-content: center;\n\n    svg {\n        path {\n            fill: ", ";\n        }\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.color.border.intense;
}, function (_a) {
    var theme = _a.theme;
    return theme.color.icon.default;
});
var templateObject_1, templateObject_2, templateObject_3;
